import { Text } from '@paygreen/paygreen-ui';
import React, { useState, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useMode } from '../../../context';
import CategoryProduct from '../addManuallyProduct/CategoryProduct';
import { patchGroupedMatchingProducts } from '../service';

const GroupedMatching = ({
    productsData,
    setIsLoading,
    handleRefreshData,
    setOpen,
    setErrorMessage,
    setDisplayMatching,
    t,
}) => {
    const [isSelecting, setIsSelecting] = useState(true);

    const { mode } = useMode();

    const defaultValues = {
        emissionExternalId: '',
        monetaryRatioMatch: '',
    };
    const methods = useForm({
        defaultValues: defaultValues,
        mode: 'onTouched',
        reValidateMode: 'onChange',
    });

    const { getValues, register } = methods;

    // Watch for changes on inputs
    useEffect(() => {
        register({ name: 'emissionExternalId' });
        register({ name: 'monetaryRatioMatch' });
    }, [register]);

    const submitValues = async () => {
        if (
            !getValues('emissionExternalId') &&
            !getValues('monetaryRatioMatch')
        ) {
            return;
        }
        const values = {
            emissionExternalId: getValues('emissionExternalId') || null,
            monetaryRatioMatch: getValues('monetaryRatioMatch') || null,
        };

        const updatedProducts = productsData.map(
            ({ productExternalReference }) => ({
                productExternalReference,
                ...values,
            }),
        );

        setIsLoading(true);

        try {
            await patchGroupedMatchingProducts(updatedProducts, mode);
            toast(
                <Text colorPallet="theme" textSize="xs">
                    {t('form.toastSuccess.matchProducts')}
                </Text>,
            );
        } catch (e) {
            setErrorMessage(t('matching.grouped.errorMatching'));
        }

        handleRefreshData(true);
        setIsLoading(false);
        setOpen(false);
    };

    const handleCancel = () => {
        setOpen(false);
        setDisplayMatching(false);
    };

    return (
        <FormProvider {...methods}>
            {
                <CategoryProduct
                    setDisplayCategoryForm={setIsSelecting}
                    matchWithSector={false}
                    displayCategoryForm={isSelecting}
                    isGrouped
                    defaultValues={defaultValues}
                    groupedSubmit={submitValues}
                    groupedCancel={handleCancel}
                />
            }
        </FormProvider>
    );
};

export default withTranslation('common')(GroupedMatching);
